export const addressTruncate = (address) => {
    const first = address.substring(0, 6)
    const last = address.substring(38, 43)
    return first + "..." + last;
}
